// Angular
import { Component, Input, OnInit, ChangeDetectorRef, ViewChild, Output, EventEmitter, HostListener, ViewRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
//Service
import { NotificationService } from './notification-service/notification.service'
import { LayoutUtilsService, MessageType } from 'app/core/_base/crud';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { NotificationModel } from './notification-model/notification.model';
import { NotificationDataSource } from './notification-datasource/notification.datasource';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { TokenStorage } from 'app/core/auth/_services';

// function dùng chung

@Component({
	selector: 'kt-notification-result',
	templateUrl: './notification-result.component.html',
	styleUrls: ['notification-result.component.scss'],
	providers: [DatePipe]
})
export class NotificationResultComponent implements OnInit {

	activeTab: string = "tab-id-1";
	user = JSON.parse(localStorage.getItem("UserInfo"));

	listNhatKyThaoTacKho: any[] = [];
	listHistoryofNotify: any[] = [];
	listHistoryofNotifyandRemind: NotificationModel[] = [];
	listGroupNotify: any[] = [];

	isShow: boolean = false;
	count: number = 0;
	pageSize = 10;
	lastPage = 0;

	currentPage = 1;
	@Output() change: EventEmitter<any> = new EventEmitter();
	@Input() offcanvas: boolean = false;
	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */

	cachedFacts = Array.from<NotificationModel>({ length: 0 });
	dataStream = new BehaviorSubject<(NotificationModel | undefined)[]>(this.cachedFacts);
	subscription = new Subscription();
	NotificationDataSource: NotificationDataSource;
	@ViewChild(CdkVirtualScrollViewport, { static: false })
	cdkVirtualScrollViewPort: CdkVirtualScrollViewport;

	constructor(
		private sanitizer: DomSanitizer,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private datePipe: DatePipe,
		private NotificationService: NotificationService,
		private router: Router,
		private tokenStorage: TokenStorage,
		private route: ActivatedRoute
	) {
	}

	@Input() pulse: boolean;
	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon: string = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon classy
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() type: 'brand' | 'success' = 'success';


	ngOnInit(): void {
		this.NotificationService.isOpenNotifyDropdown$.subscribe(res => {

			//Notify by card
			if (this.listHistoryofNotifyandRemind.length == 0) {
				this.LoadListHistoryNotifyandRemind();
			}
			else {
				this.openChange();
				setInterval(r => {
					this.LoadListHistoryNotifyandRemind();
					this.changeDetectView();
				}, 60000)
			}

			//Notify by group
			if(this.listGroupNotify.length == 0){
				this.loadGroupNotify();
			}
			else {
				this.openChange();
				setInterval(r => {
					this.loadGroupNotify();
					this.changeDetectView();
				}, 10000)
			}
		})
	}
	loadGroupNotify() {
		this.NotificationService.getDataGroupNotify().subscribe(res => {
			if (res && res.status == 1 && res.data) {
				this.listGroupNotify = [];
				res.data.forEach(x => {
					this.listGroupNotify.push(x)
				})
				this.changeDetectView();
			}
		})
	}
	LoadListHistoryNotifyandRemind(isCompareLast: boolean = true) {
		this.NotificationService.getDataHistoryNotifyandRemind(this.user.id, this.user.IdChucdanh, this.user.cocauid).subscribe(res => {
			if (res && res.status == 1) {
				if (isCompareLast) {
					if ((this.listHistoryofNotifyandRemind.length > 0 &&
						this.listHistoryofNotifyandRemind.length != res.data.length)
						|| this.listHistoryofNotifyandRemind.length == 0) {
						this.copyValue(res.data)
					}
					else if (this.listHistoryofNotifyandRemind.length == res.data.length) {
						var isChange = false;
						for (var i = 0; i < this.listHistoryofNotifyandRemind.length; i++) {
							if (this.listHistoryofNotifyandRemind[i].TrangThai != res.data[i].TrangThai) {
								isChange = true;
								break;
							}
						}
						if (isChange)
							this.copyValue(res.data)
					}
				}
				else {
					this.copyValue(res.data)
				}

				this.count = this.listHistoryofNotifyandRemind.filter(x => x.TrangThai == 0).length;
				this.change.emit(this.count);
				this.NotificationService.totalNof$.next(this.count);

				this.changeDetectView();
			}
		})
	}
	loadDetailNotification(item: NotificationModel) {
		if (item.TrangThai == 1) {
			let Routing = FunctionPublic.ConvertPageroutingToNotifcation(item.LinkPhieu);
			if (item.LinkPhieu) {
				if(item.Loai != -1){
					this.router.navigate([Routing.page_routing],
					{
						queryParams: {
							Id: Routing.id,
							Loai: item.Loai
						},
					});
				}else{
					this.router.navigateByUrl(item.LinkPhieu);
				}
			}
		}
		else {
			this.NotificationService.updateStatusHistoryNotifyandRemind(item).subscribe(res => {
				if (res && res.status == 1) {
					this.LoadListHistoryNotifyandRemind(false)
					let Routing = FunctionPublic.ConvertPageroutingToNotifcation(item.LinkPhieu);
					if (item.LinkPhieu) {
						if(item.Loai != -1)
							this.router.navigate([Routing.page_routing], { queryParams: { Id: Routing.id, routerlink: `${this.router.url}` }, skipLocationChange: true });
						else
							this.router.navigateByUrl(item.LinkPhieu);
					}
				} else {
					let _message = res.error;
					this.layoutUtilsService.showErorr(_message);
				}
			})
		}
	}
	RemoveNotification(item: NotificationModel) {

		this.NotificationService.removeHistoryNotifyandRemind(item).subscribe(res => {
			if (res && res.status == 1) {
				let _message = "Xóa thành công";
				this.layoutUtilsService.showInfo(_message);
				this.LoadListHistoryNotifyandRemind(false);
				this.changeDetect.detectChanges();

			} else {
				let _message = res.error;
				this.layoutUtilsService.showErorr(_message);
			}
		})
	}
	copyValue(newValue: any[]) {
		this.listHistoryofNotifyandRemind = [];
		newValue.forEach(element => {
			var tmp = new NotificationModel();
			tmp.clear();
			tmp.copy(element)

			this.listHistoryofNotifyandRemind.push(tmp)
		});
	}
	getDataGroupNoti(item: any){
		if(item != null){
			// this.NotificationService.getDataDetailGroupNotify(item.Link, item.IdLoaiTb, item.IdUser)
			// 						.subscribe(res => {

			// 						})
			this.router.navigateByUrl(item.Link.trim());
		}
	}


	backGroundStyle(): string {
		if (!this.bgImage || this.skin === 'light') {
			return 'none';
		}
		return 'url(' + this.bgImage + ')';
	}
	_getPageForIndex(i: number): number {
		return Math.floor(i / this.pageSize);
	}
	openChange() {
		this.cdkVirtualScrollViewPort.scrollToIndex(0);
		this.cdkVirtualScrollViewPort.checkViewportSize();
	}
	formatDateTime(datetime) {
		return datetime = this.datePipe.transform(datetime, 'dd/MM/yyyy HH:mm:ss');
	}
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	async markAllRead() {
		let res = await this.NotificationService.markAllRead(Number(this.user.id)).toPromise();
		if (res != undefined && res.status == 1) {
			this.LoadListHistoryNotifyandRemind();
			this.changeDetect.detectChanges();
		}
	}
}